import React from "react";
import "./index.scss";
import PropTypes from "prop-types";
import { Anchor, Col, Row } from "antd";
import LazyImage from "components/atoms/LazyImage";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import BackToTop from "components/atoms/BackToTop";
import QueueAnim from 'rc-queue-anim';

const { Link } = Anchor;
const PageClient = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="page-client-content">
        <Row justify="center">
          {props.headerImage !== null && (
            <Col span={24} className="header-image-content">
              <LazyImage alt="header-image" src={props.headerImage} />
              <div
                className={classNames(
                  "page-header-description",
                  `page-header-description--${
                    i18n.language === "ar" ? "ar" : "fr"
                  }`
                )}
              >
                <div className="title">{t(props.title)}</div>
                <div className="desciption">{t(props.description)}</div>
              </div>
            </Col>
          )}

          <Col span={24} className="page-content">
            <div
              className={classNames(
                "menu-page",
                `menu-page--${props.menu.length <= 0 && "invisible"}`
              )}
            >
              <Anchor
                className={classNames(
                  "anchor-menu",
                  `anchor-menu--${i18n.language === "ar" ? "ar" : "fr"}`
                )}
              >
                <QueueAnim delay={300}>
                  {props.menu &&
                    props.menu.length > 0 &&
                    props.menu.map((item, index) => (
                      
                      <div className="anchor-item-menu" key={index}>
                        <Link href={item.id} title={t(item.title)} key={index} />
                        <div className="separator"></div>
                      </div>
                    ))}
                  </QueueAnim>
              </Anchor>
            </div>
            <div
              className={classNames(
                "content-page",
                `content-page--${props.menu.length <= 0 && "invisible"}`
              )}
            >
              {props.children}
            </div>
          </Col>
        </Row>
        <BackToTop />
      </div>
    </>
  );
};

PageClient.propTypes = {
  menu: PropTypes.array,
  headerImage: PropTypes.node,
  description: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default PageClient;
